export default __webpack_public_path__ + "static/media/icon-Connect-Challenges.76430226.svg";